import { FC, useEffect, useMemo } from 'react'

import { Stack, Typography } from '@mui/material'

import Title from './Title'
import useHiddenFormElement from '../hooks/useHiddenFormElement'
import useAnalytics from '../hooks/useAnalytics'

const ErrorPage: FC = () => {
  const descriptionElement = useHiddenFormElement('.error-page-help')
  const description = useMemo(() => descriptionElement?.innerText ?? '', [descriptionElement])

  const detailElement = useHiddenFormElement('.error-page-detail')
  const detail = useMemo(() => detailElement?.innerText ?? '', [detailElement])

  const correlationIdElement = useHiddenFormElement('.error-page-correlationid')
  const correlationId = useMemo(() => correlationIdElement?.innerText ?? '', [correlationIdElement])

  const analytics = useAnalytics('error_page')
  useEffect(() => {
    analytics.onOther('error', { description, detail })
  }, [analytics, description, detail])

  return (
    <Stack spacing={6}>
      <Title>An error occurred</Title>
      <Typography>{description}</Typography>
      <Stack>
        <Typography variant="caption">{detail}</Typography>
        <Typography variant="caption">{correlationId}</Typography>
      </Stack>
    </Stack>
  )
}

export default ErrorPage
